export default __webpack_public_path__ + "static/media/AddOrgTeam.216a8b97.png";